// src/components/navigation/SidebarNav.js

import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import Logo from "../../assets/Logo.png";
import LockedFeatureItem from "./LockedFeatureItem";

// MAIN NAV ITEMS (top section)
const mainNavItems = [
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
        />
      </svg>
    ),
  },
  {
    to: "/sample-orders",
    label: "Sample Orders",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        />
      </svg>
    ),
  },
  {
    to: "/orders",
    label: "Orders",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M20 7H4m16 0l-1.5 11a2 2 0 01-1.985 1.73H7.485A2 2 0 015.5 18L4 7m16 0L17 4H7L4 7m4 5h8m-8 4h5"
        />
      </svg>
    ),
  },
  {
    to: "/inventory",
    label: "Inventory",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        />
      </svg>
    ),
  },
  {
    to: "/accounts",
    label: "Accounts",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2a5 5 0 00-9.288-2.143M7 20H2v-2a3 3 0 015.356-1.857M12 7a3 3 0 11-6 0 3 3 0 016 0zm8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
    ),
  },
  {
    to: "/territories-map",
    label: "Map",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 20l-5.447-2.724A2 2 0 013 15.382V5.618a2 2 0 011.105-1.789L9 2m0 18l6-3m-6 3V2m6 15l4.895 2.447A2 2 0 0021 17.618V7.382a2 2 0 00-1.105-1.789L15 4m0 13V4m0 0L9 2"
        />
      </svg>
    ),
  },
  {
    to: "/tasks",
    label: "Tasks",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12l2 2 4-4m1-5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2z"
        />
      </svg>
    ),
  },
];

// SETTINGS / SECONDARY NAV (bottom section)
const settingsNavItems = [
  {
    to: "/settings",
    label: "Profile & Company",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
        />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    to: "/team",
    label: "Team",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2a5 5 0 00-9.288-2.143M7 20H2v-2a3 3 0 015.356-1.857M12 7a3 3 0 11-6 0 3 3 0 016 0zm8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
    ),
  },
];

// Documents (moved to bottom section, second-to-last above Admin)
const documentsNavItem = {
  to: "/documents",
  label: "Documents",
  icon: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
      />
    </svg>
  ),
};

// Admin-only settings item
const adminNavItem = {
  to: "/admin",
  label: "Admin",
  icon: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
      />
    </svg>
  ),
};

const SidebarNav = ({
  companyName = "SupplyHawk",
  onOpenContact,
  onOpenLegal, // (tab) => void, tab = "terms" | "privacy"
  featureAccess = {},
}) => {
  const auth = getAuth();
  const db = getFirestore();

  const [userRole, setUserRole] = useState(null);
  const [, setCompanyId] = useState(null);

  const [brandName, setBrandName] = useState(companyName);
  const [companyLogoUrl, setCompanyLogoUrl] = useState("");
  const [logoError, setLogoError] = useState(false);

  const [loadingRole, setLoadingRole] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      setLoadingRole(true);
      setLogoError(false);

      if (!firebaseUser) {
        setUserRole(null);
        setCompanyId(null);
        setBrandName(companyName);
        setCompanyLogoUrl("");
        setLoadingRole(false);
        return;
      }

      try {
        const userRef = doc(db, "users", firebaseUser.uid);
        const snap = await getDoc(userRef);

        if (snap.exists()) {
          const data = snap.data() || {};
          const role = data.role || null;
          const compId = data.companyId || firebaseUser.uid;

          setUserRole(role);
          setCompanyId(compId);

          // Pull company brand + logo (if present)
          try {
            const companyRef = doc(db, "companies", compId);
            const cSnap = await getDoc(companyRef);
            if (cSnap.exists()) {
              const c = cSnap.data() || {};
              const name = c.businessName || c.name || companyName;
              const logo = c.logoUrl || c.logoURL || c.logo || "";
              setBrandName(name || companyName);
              setCompanyLogoUrl(logo || "");
            } else {
              setBrandName(companyName);
              setCompanyLogoUrl("");
            }
          } catch (err) {
            console.warn("[SidebarNav] Error loading company brand:", err);
            setBrandName(companyName);
            setCompanyLogoUrl("");
          }
        } else {
          setUserRole(null);
          setCompanyId(firebaseUser.uid);
          setBrandName(companyName);
          setCompanyLogoUrl("");
        }
      } catch (err) {
        console.error("[SidebarNav] Error loading user role:", err);
        setUserRole(null);
        setCompanyId(null);
        setBrandName(companyName);
        setCompanyLogoUrl("");
      } finally {
        setLoadingRole(false);
      }
    });

    return () => unsub();
  }, [auth, db, companyName]);

  const isAdminUser = userRole === "admin" || userRole === "owner";

  // Bigger font + slightly less padding, icons more present
  const navLinkClass = ({ isActive }) =>
    [
      "flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg text-sm font-medium transition-colors",
      isActive
        ? "bg-sky-100 text-sky-800"
        : "text-slate-700 hover:bg-slate-50 hover:text-slate-900",
    ].join(" ");

  const openContact = () => {
    if (typeof onOpenContact === "function") return onOpenContact();
  };

  const openLegal = (tab) => {
    if (typeof onOpenLegal === "function") return onOpenLegal(tab);
  };

  if (loadingRole) return null;
  if (userRole === "customer") return null;

  const headerLogoSrc = logoError ? Logo : (companyLogoUrl || Logo);

  return (
    <aside className="hidden md:flex md:flex-col w-64 bg-white border-r border-slate-200 shadow-sm fixed top-0 left-0 bottom-0 z-40">
      <div className="flex flex-col h-full">
        {/* Brand header (compact + fixed) */}
        <div className="h-16 flex items-center px-4 border-b border-slate-100 flex-shrink-0">
          <div className="flex items-center gap-2">
            <img
              src={headerLogoSrc}
              alt={brandName || "Company"}
              onError={() => setLogoError(true)}
              className="h-9 w-9 object-contain rounded-md bg-white"
            />
            <div className="leading-tight min-w-0">
              <div className="text-sm font-semibold tracking-tight text-slate-900 truncate">
                {brandName || companyName}
              </div>
              <div className="text-[10px] text-slate-500 font-medium tracking-wide">
                FIELD SALES HUB
              </div>
            </div>
          </div>
        </div>

        {/* Nav (only scroll area) */}
        <nav className="flex-1 min-h-0 px-2 py-3 space-y-0.5 overflow-y-auto">
          {mainNavItems.map((item) => {
            const featureKey = item.to === "/orders"
              ? "orders"
              : item.to === "/territories-map"
                ? "map"
                : null;
            const access = featureKey ? featureAccess?.[featureKey] : null;
            if (access?.reason === "hidden_entirely") {
              return null;
            }
            const locked = !!access && access.allowed === false;

            if (locked) {
              return (
                <LockedFeatureItem
                  key={item.to}
                  label={item.label}
                  icon={item.icon}
                  message={access?.lockMessage || (access?.reason === "paid_only" ? "Paid plan required" : "Hidden by developer")}
                  className="flex w-full items-center gap-2.5 rounded-lg border border-slate-200 bg-slate-50 px-2.5 py-1.5 text-left text-sm font-medium text-slate-400"
                  iconClassName="flex-shrink-0 text-slate-400"
                  labelClassName="truncate flex-1"
                  lockClassName="h-3.5 w-3.5"
                  bubbleClassName="w-56"
                />
              );
            }

            return (
              <NavLink key={item.to} to={item.to} className={navLinkClass}>
                {({ isActive }) => (
                  <>
                    <span
                      className={[
                        "flex-shrink-0",
                        isActive ? "text-sky-700" : "text-slate-400",
                      ].join(" ")}
                    >
                      {item.icon}
                    </span>
                    <span className="truncate">{item.label}</span>
                  </>
                )}
              </NavLink>
            );
          })}

          {/* ✅ Secondary section with title + Documents moved here */}
          <div className="mt-4 pt-3 border-t border-slate-100">
            <div className="px-2.5 pb-2 text-[10px] font-semibold uppercase tracking-wider text-slate-400">
              Company
            </div>

            {settingsNavItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={navLinkClass}>
                {({ isActive }) => (
                  <>
                    <span
                      className={[
                        "flex-shrink-0",
                        isActive ? "text-sky-700" : "text-slate-400",
                      ].join(" ")}
                    >
                      {item.icon}
                    </span>
                    <span className="truncate">{item.label}</span>
                  </>
                )}
              </NavLink>
            ))}

            {/* ✅ Documents is now second-to-last (above Admin) */}
            <NavLink key={documentsNavItem.to} to={documentsNavItem.to} className={navLinkClass}>
              {({ isActive }) => (
                <>
                  <span
                    className={[
                      "flex-shrink-0",
                      isActive ? "text-sky-700" : "text-slate-400",
                    ].join(" ")}
                  >
                    {documentsNavItem.icon}
                  </span>
                  <span className="truncate">{documentsNavItem.label}</span>
                </>
              )}
            </NavLink>

            {isAdminUser && (
              <NavLink key={adminNavItem.to} to={adminNavItem.to} className={navLinkClass}>
                {({ isActive }) => (
                  <>
                    <span
                      className={[
                        "flex-shrink-0",
                        isActive ? "text-sky-700" : "text-slate-400",
                      ].join(" ")}
                    >
                      {adminNavItem.icon}
                    </span>
                    <span className="truncate">{adminNavItem.label}</span>
                  </>
                )}
              </NavLink>
            )}
          </div>
        </nav>

        {/* Bottom pinned (SUPER COMPRESSED support + legal links) */}
        <div className="flex-shrink-0 border-t border-slate-200 bg-white px-3 py-2">
          <div className="flex items-center justify-between gap-2">
            <button
              type="button"
              onClick={openContact}
              className="text-[11px] font-medium text-slate-600 hover:text-slate-900 hover:underline truncate"
              title="Contact SupplyHawk"
            >
              Contact
            </button>

            <div className="flex items-center gap-2 text-[11px]">
              <button
                type="button"
                onClick={() => openLegal("terms")}
                className="text-slate-500 hover:text-slate-900 hover:underline"
              >
                Terms
              </button>
              <span className="text-slate-300">•</span>
              <button
                type="button"
                onClick={() => openLegal("privacy")}
                className="text-slate-500 hover:text-slate-900 hover:underline"
              >
                Privacy
              </button>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default SidebarNav;
